export const PRICE_LABEL = '$25.999'
export const PRICE_STRIKE_LABEL = '$51.999'
export const TOTAL_VALUE = 106
export const CHECKOUT_URL = 'https://dominio-del-picklebal.impultienda.ar/checkout'
export const META_PIXEL_ID = '28236724749285303'
export const PRICE_VALUE = 25999
export const CURRENCY = 'ARS'

export interface OfferItem {
  label: string
  title: string
  description: string
  value: number
  main?: boolean
}

export const offerItems: OfferItem[] = [
  {
    label: 'Guía Principal',
    title: 'Dominio del Pickleball',
    description:
      '60 páginas con el sistema táctico paso a paso: posicionamiento, lectura del rival y decisiones en cada golpe.',
    value: 47,
    main: true,
  },
  {
    label: 'Bonus 1',
    title: 'Guía de Reglas y Faltas Comunes',
    description:
      'Las reglas que casi nadie conoce y las faltas que se cobran mal, explicadas simple para que no te vuelvan a robar un punto.',
    value: 27,
  },
  {
    label: 'Bonus 2',
    title: 'Checklist Táctico del Kitchen',
    description:
      'Diagramas de bolsillo para abrir en tu celular en medio del partido y corregir tu posición sobre la marcha.',
    value: 17,
  },
  {
    label: 'Bonus 3',
    title: 'Rutina de Práctica por Situaciones',
    description:
      'Ejercicios ordenados por situación de juego para llevar a la cancha y entrenar cada patrón hasta que salga solo.',
    value: 15,
  },
]

export const painPoints: string[] = [
  'Sentir que te "bombardean" en la red y no saber cómo reaccionar.',
  'Regalar puntos fáciles por no entender el tercer golpe suave hacia la zona de no-volea.',
  'Ver cómo oponentes con menos técnica te ganan solo porque saben posicionarse mejor.',
  'Terminar los partidos con la sensación de que podrías haber ganado si hubieras sabido qué hacer en los momentos clave.',
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Es para principiantes?',
    answer:
      'Sí, y también para intermedios que vienen de otros deportes de raqueta como tenis o pádel. El sistema arranca desde el posicionamiento básico y escala hasta patrones avanzados de dobles.',
  },
  {
    question: '¿Es un libro físico?',
    answer:
      'No. Es un producto digital de acceso inmediato: al comprar recibís los archivos por email y podés leerlos hoy mismo en tu celular, tablet o computadora.',
  },
  {
    question: '¿Necesito estar en forma?',
    answer:
      'No. Justamente este sistema se basa en la inteligencia táctica y la ocupación de espacios para que no tengas que correr de más ni pegar más fuerte que tu rival.',
  },
  {
    question: '¿En cuánto tiempo voy a ver resultados?',
    answer:
      'La mayoría nota el cambio en los primeros 3 partidos, cuando empieza a aplicar el tercer golpe y el avance coordinado hacia la red. El sistema completo está pensado para 30 días.',
  },
]

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/49469e2d-f871-40aa-93e5-1af110129d55.jpg',
  devices:
    'https://cdn.magicpatterns.com/patterns/generated-images/5ed180a0-4cb5-4e31-9b03-ce89b0606c3c.jpg',
  diagram:
    'https://cdn.magicpatterns.com/patterns/generated-images/8262e744-6d9e-4323-a607-b3cf6ee24df4.jpg',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/17f26afd-fb94-40fc-83a3-c5e1d9cc2873.jpg',
  cheatsheet:
    'https://cdn.magicpatterns.com/patterns/generated-images/a99e70b5-c863-4eba-a90e-f95de561bd92.jpg',
}
